import React from 'react';
import { Clock } from 'lucide-react';

export default function EmployeeTableRow({ employee }) {
  // Extracting employee data
  const { employeeName, totalWorkTime } = employee;
  return (
    <tr>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div className="h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center">
            <span className="text-sm font-medium text-blue-600">
              {employeeName.charAt(0)} {/* Display the first letter of employee name */}
            </span>
          </div>
          <div className="ml-4">
            <div className="text-sm font-medium text-gray-900">
              {employeeName} {/* Display full employee name */}
            </div>
          </div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center text-sm text-gray-900">
          <Clock className="h-4 w-4 mr-2 text-gray-500" />
          {totalWorkTime} {/* Display total work time */}
        </div>
      </td>
    </tr>
  );
}
